"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var advertiserBuilder = function advertiserBuilder(_a) {
  var advertiserId = _a.advertiserId;

  if (!advertiserId) {
    return '';
  }

  return "advertiserId:" + advertiserId;
};

var _default = advertiserBuilder;
exports["default"] = _default;